(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PushNotificationService', PushNotificationService);

    PushNotificationService.$inject = ['$resource', '$localStorage', '$sessionStorage'];

    function PushNotificationService($resource, $localStorage, $sessionStorage) {
        //for test
        const firebaseConfig = {
            apiKey: "AIzaSyBI_c5nRLDb3FBRmiX7gqH7_Z7110oobTo",
            authDomain: "planovin.firebaseapp.com",
            projectId: "planovin",
            storageBucket: "planovin.appspot.com",
            messagingSenderId: "396654432408",
            appId: "1:396654432408:web:0aa1f6341b478cbbe500ed",
            measurementId: "G-YPZNSC89W1"
        }
        
        function getCurrentNotificationToken() {
            console.log("GET CURRENT NOTIFICATION TOKEN")

            new Promise(function (resolve, reject) {
                resolve("XXXXXXX")
            })
        }

        function initPushNotification() {
            if (document && document.readyState && document.readyState !== 'complete' && window) window.addEventListener("load", function () {
                registerFirebaseAndCheckNotificationStatus()
            })
            else {
                registerFirebaseAndCheckNotificationStatus()
            }
        }

        //check for support service worker
        function registerFirebaseAndCheckNotificationStatus() {
            if (navigator && navigator.permissions && 'serviceWorker' in navigator && 'PushManager' in window) {
                //service worker is ready
                navigator.serviceWorker.ready.then(function () {
                    //create firebase app
                    initializeApp(firebaseConfig)

                    //get notification permission state
                    getNotificationPermissionState()
                        .then(function (result) {
                            // state is granted and firebase token has not been subscribe to a topic yet
                            if (result.state === 'granted') subscribeAndSendToServer()
                            else if (result.state === 'prompt') getNotificationPermissionAndGetToken()
                        })

                })


            } else if (window && window.nsWebViewInterface) {
                // emit event to native app
                window.nsWebViewInterface.emit('isNativeApp', "isNativeApp");
                window.nsWebViewInterface.emit('getNotificationToken', "getNotificationToken");
                
                // register listener for any event from native app
                window.nsWebViewInterface.on('isNativeApp', getNotificationIsNativeApp);
                window.nsWebViewInterface.on('receiveNotificationToken', getNotificationFromNativeApp);
            }
        }

        // get permission and get token
        function getNotificationPermissionAndGetToken() {
            Notification.requestPermission().then(function (result) {
                if (result !== 'granted') return
                getNotificationToken().then(function (currentToken) {
                    subscribeAndSendToServer(currentToken, "web")
                })

            })

        }

        // send new user notification token to server
        function setUserToken(token, platform) {
            // REQUEST TO SERVER AS USER TO SERVER
            console.log("SET USER NOTIFICATION TOKEN")
            // var resourceUrl = 'TEST';
            // return $resource(resourceUrl, {}, {
            //         'post': {
            //             method: 'POST', params: {}, data : {token , platform}
            //         }
            //     }
            // );
        }

        // get notification token from firebase
        function getNotificationToken() {
            navigator.serviceWorker.ready.then(function () {
                var messaging = getMessagingInWindow()
                return getToken(messaging, {vapidKey: 'BEN5jt-yXfKpV84KFGaDgwOJi-axh_HlOl4NWwAsNGPm_j4SWdl_6yM0IibA0wIsfhx5y4mNlJPen5auTeGE9Jg'})
                    .then(function (result) {
                        return result
                    })
            })
        }

        // get notification permissions state
        function getNotificationPermissionState() {

            return navigator.permissions.query({name: 'notifications'})
                .then(function (result) {
                    return Promise.resolve(result)
                })
        }

        // subscribe all token to a topics
        function subscribeToATopic(token) {

            $sessionStorage.subscribedTopic = "true"
            // var data = {
            //     topics: ['ALL'],
            //     token: token
            // }
            // SEND REQUEST TO SERVER TO SUBSCRIBE TOKEN TO A TOPIC
        }

        //  receive notification token from native app (android or ios)
        function getNotificationFromNativeApp(data) {
            subscribeAndSendToServer(data.token, data.platform)
        }

        //subscribe token and send it to server if user is logged in
        function subscribeAndSendToServer(token, platform) {
            var currentToken
            new Promise(function (resolve, reject) {
                if (!token) {
                    //get notification permission status to ensure
                    getNotificationPermissionState()
                        .then(function (result) {
                            if (result.state !== 'granted') return
                            getNotificationToken().then(function (result) {
                                currentToken = result
                                resolve()
                            })
                        })


                } else currentToken = token
            })
                .then(function () {
                    if ($sessionStorage.subscribedTopic !== 'true') subscribeToATopic(currentToken)

                    if (isUserLoggedIn()) {
                        // get current user token
                        getCurrentNotificationToken().then(function (tokenResponse) {
                            if (tokenResponse !== currentToken) setUserToken(currentToken, platform)
                        })

                    }
                })
        }

        // check is user logged in
        function isUserLoggedIn() {
            if ($localStorage.authenticationToken) return true
            else return false
        }
        function getNotificationIsNativeApp(data) {
            if(data) {
                $localStorage.isNativeApp = "true";
            }else {
                delete $localStorage.isNativeApp
            }
        }

        return {
            "initPushNotification": initPushNotification
        }
    }
})();

